// This file is auto-generated by the installer.
import { FC } from 'react';
import xetuxProducts from 'plugins/xetux-products';
import toastProducts from 'plugins/toast-products';


export type PluginsList = {
    readonly "xetux-products" : FC;
readonly "toast-products" : FC;
};

export const plugins: PluginsList = {
    "xetux-products" : xetuxProducts as FC,
"toast-products" : toastProducts as FC
}

